import { useEffect, useState } from 'react'
import { readTheme, writeTheme, applyTheme, nextTheme, resolveTheme, systemPrefersDark } from '../lib/theme'

/**
 * One control that flips between light and dark.
 *
 * A single button rather than a menu: this is a preference someone sets once
 * and then forgets, and it should cost one click to correct if the room
 * changes. The tooltip carries the full state, since the icon can only show
 * where you are, not where you can go.
 */

const ICONS = {
  light: <path d="M8 2.6v1.2M8 12.2v1.2M2.6 8h1.2M12.2 8h1.2M4.4 4.4l.85.85M10.75 10.75l.85.85M11.6 4.4l-.85.85M5.25 10.75l-.85.85M8 5.4a2.6 2.6 0 100 5.2 2.6 2.6 0 000-5.2z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />,
  dark: <path d="M13 9.2A5.4 5.4 0 016.8 3a5.6 5.6 0 100 12.4 5.6 5.6 0 006.2-6.2z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" transform="translate(-0.5,-1.2)" />,
  system: <path d="M2.5 3.2h11v7h-11zM6 12.8h4M8 10.2v2.6" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />,
}

const LABEL = { system: 'Match system', light: 'Light', dark: 'Dark' }

export default function ThemeToggle({ compact = false }) {
  const [theme, setTheme] = useState(() => readTheme())

  useEffect(() => { applyTheme(theme) }, [theme])

  function step() {
    const next = nextTheme(theme)
    setTheme(next)
    writeTheme(next)
  }

  const showing = resolveTheme(theme, systemPrefersDark())

  return (
    <button
      onClick={step}
      title={LABEL[theme]}
      aria-label={`Theme: ${LABEL[theme]}. Click to change.`}
      className="tb-icon"
      style={{
        display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0,
        justifyContent: 'center', minWidth: 36, height: 36, boxSizing: 'border-box',
        padding: compact ? 0 : '0 10px',
        background: 'transparent', border: '1px solid transparent',
        cursor: 'pointer',
        fontFamily: 'var(--fu)', fontSize: 11, fontWeight: 600,
      }}
    >
      <svg width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true">{ICONS[theme]}</svg>
      {!compact && <span>{LABEL[theme]}</span>}
    </button>
  )
}
